type SpotlightResultType =
	| 'Asset'
	| 'Collection'
	| 'Guideline'
	| 'MetapropertyOption'
	| 'Tag'
	| 'GENERIC';

export const getSpotlightResultClassName = (type: SpotlightResultType) => {
	return type === 'GENERIC' ? 'spotlightDropdownResult' : `spotlightDropdownResult_${type}`;
};
